import { sendPostCallToSever } from "../Axios/Axios";

const ContactUsPost = (
  payload: Record<string, unknown>,
  setOpen: (open: boolean) => void
) => () => {
  return sendPostCallToSever(payload, "contact")
    .then(() => {
      setOpen(false);
      return true;
    })
    .catch((error) => {
      console.error("Contact Us submission failed:", error);
      return false;
    });
};

export { ContactUsPost };
